import constants from '@constants';

export const locationDetails = {
	points                 : [],
	options                : [],
	filter                 : 'all',
	mapCenter              : constants.GOOGLE_MAP_SETTINGS.defaultCenter,
	highlightedMarker      : '',
	restrictionDescription : 'None',
	job                    : {
		name          : '',
		startDateTime : '',
		endDateTime   : '',
		location      : constants.GOOGLE_MAP_SETTINGS.defaultCenter,
	},
	feed : {
		list        : [],
		pagingToken : '',
		hasNext     : true,
	},
};

export default {
	locationDetails,
};
